module.exports = __webpack_public_path__ + "img/ResourceGold_ua.a140799f.webp";